import React from "react";
import TextField from "../TextField/TextField";

const Home = () => {
	return (
		<div className="p-1">
				<TextField />			
		</div>
	);
};

export default Home;
